// "Kopfleiste über dem Banner" of a one page (scss/pages/_onepage.scss, #header.header-overlay): the dark shade from above
// turns into the surface of the bar while the page is scrolled, not at one point. --overlay-p runs from 0 (top of the page)
// to 1 over the height of the bar itself, so the lower edge of the shade, twice as high as the bar, goes up with the
// content; from the middle on (header-overlay--solid) the lettering takes the colors of the bar.
// When the scrolling stops on the way, the bar does not stay half done: it runs on to the nearer end (shade or surface,
// header-overlay--settling) and the way from there on is measured anew, so the next scroll goes on from where it stands.
// header-overlay--past-banner: the banner has gone below the shade (style "keep" takes the surface then).
// Without JavaScript the bar stays as it is at the top of the page.
export default function initHeaderOverlay() {
    const section = document.querySelector('#header.header-overlay');
    const header = section?.querySelector('header');
    const banner = document.getElementById('top');
    if (!header) {
        return;
    }

    let range = header.offsetHeight;
    // the scroll positions where the progress is 0 and 1; moved when the bar settles on the way
    let from = 0;
    let to = range;
    let progress = 0;
    let frame = 0;
    let idle = 0;

    const show = (value) => {
        progress = value;
        section.style.setProperty('--overlay-p', value.toFixed(3));
        section.classList.toggle('header-overlay--solid', value >= .5);
    };
    const update = () => {
        frame = 0;
        const y = window.scrollY;
        if (y <= 0 || y >= range) {
            from = 0;
            to = range;
        }
        show(Math.min(1, Math.max(0, (y - from) / Math.max(to - from, 1))));
        // the shade of "keep" reaches one and a half bars below the top
        section.classList.toggle('header-overlay--past-banner', !!banner && banner.getBoundingClientRect().bottom <= header.offsetHeight * 1.5);
    };
    const settle = () => {
        if (progress <= 0 || progress >= 1) {
            return;
        }
        const y = window.scrollY;
        if (progress >= .5) {
            from = 0;
            to = y;
        } else {
            from = y;
            to = range;
        }
        section.classList.add('header-overlay--settling');
        show(progress >= .5 ? 1 : 0);
    };

    window.addEventListener('scroll', () => {
        section.classList.remove('header-overlay--settling');
        if (!frame) {
            frame = window.requestAnimationFrame(update);
        }
        window.clearTimeout(idle);
        idle = window.setTimeout(settle, 150);
    }, {passive: true});
    // the bar is measured in its full height only at the top (it shrinks once the page is scrolled)
    window.addEventListener('resize', () => {
        if (window.scrollY === 0) {
            range = header.offsetHeight;
            to = range;
        }
    });
    update();
    settle();
}
